import React from "react";

import ParallaxImage from "../ParallaxImage";
import { ReactLenis } from "@studio-freight/react-lenis";
import "../../css/SelectionBg.css";
import InteriorDesignResidentialSelectionComponent from "../InteriorDesignComponents/InteriorDesignResidentialSelection";
import LuxeSelection from "../Selection2/LuxeSelection";
import BeysuSelection from "../Selection2/BeysuSelection";
import BeysuShow from "../InteriorDesignComponents/InteriorShow/BeysuShow";

export default function BeysuComponent() {
  return (
    <ReactLenis root>
      <div className="app1">
        <section className="hero">
          <div className="img">
            <ParallaxImage
              src="../../Images/ResidentialImages/Beysu/2a.jpg"
              alt=""
            />
          </div>

          <div className="nav">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingTop: "200px",
              }}
            >
              <p className="p5">BEYSU MANSIONS</p>
              {/* <p>COMMERCIAL INTERIOR DESIGN</p>
              <p>EXTERIOR DESIGN</p> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: "10px",
                  color: "#e7e7e7",
                  textTransform: "uppercase",
                  fontSize: "20px",
                }}
              >
                <span>
                  role in project: architectural drawings, 3d visualization
                </span>
                <span>project duration: 3 months</span>
                <span>year of completion: 2022</span>
                <span>project location:Beysukent, Ankara-TURKIYE</span>
              </div>
            </div>
          </div>
        </section>
        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "35px",
                  textTransform:"uppercase",
                  padding:"50px"
                }}
              >
                versatile layouts, high-quality materials, and sophisticated
                designs cater to diverse lifestyles in beysu mansions. With
                features like mezzanine floors and open-plan kitchens, the
                layout offer spacious and connected living.
              </h1>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>
        <section className="projects">
          <div className="img">
            <ParallaxImage
              src="../../Images/ResidentialImages/Beysu/1B.jpg"
              alt=""
            />
          </div>

          {/* <div className="projects-brief">
              <p
                style={{
                    color:"black",
                    fontSize:"30px"
                }}
              >
              This modern living space and bedroom are designed to inspire with its elegant lines, warm tones, and luxurious finishes, creating an inviting ambiance for both relaxation and entertaining.
              </p>
            </div> */}

          <div className="col projects-cover">
            <div
              className="img"
              style={{
                marginTop: "1000px",
                zIndex: "9999",
              }}
            >
              {/* <ParallaxImage
                src="../../Images/ResidentialImages/Beysu/Banyo5.jpg"
                alt=""
              /> */}
            </div>
          </div>

          <div className="col projects-list">
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                }}
              >
                ARCHITECTURALLY
                <br />
                CRAFTED
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                }}
              >
                SHAPING
                <br />
                LUXURY{" "}
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                }}
              >
                AND
                <br />
                FUNCTIONALITY
              </h1>
            </div>
          </div>
        </section>



        <section className="about">
          <div className="col intro">
            <p>ABOUT</p>
            <p
              style={{
                width: "450px",
              }}
            >
              The Beysu Mansions project combines modern elegance with practical
              functionality across its different layouts, designed to suit
              various lifestyle needs. Focused on luxury and contemporary
              living, each residence incorporates high-quality materials, smart
              layouts, and elegant designs. One layout includes a mezzanine
              floor, adding a sense of openness and maximizing space with large
              double-height living areas. The other layout features an open-plan
              kitchen connected to the main living area. This design ensures a
              connected, bright atmosphere, perfect for modern family life and
              social gatherings.
            </p>
          </div>
          <div className="col portrait">
            <div className="portrait-container">
              <div className="img">
                <ParallaxImage
                  src="../../Images/ResidentialImages/Beysu/5A.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </section>

        <section className="banner">
          <BeysuSelection />
        </section>
        <div
          style={{
            padding: "50px",
          }}
        >
          <BeysuShow />
        </div>
       
        <section className="banner">
          <div className="img">
            <ParallaxImage
              src="../../Images/ResidentialImages/Beysu/1.2.r.jpg"
              alt=""
            />
          </div>

          {/* <div className="banner-copy">
              <p
              
              >Location:</p>
              <h1
                style={{
                    color:"#1a1a1a"
                }}
              >Yenimahalle, </h1>
             <h1
               style={{
                color:"#1a1a1a"
            }}
             >Ankara-TURKIYE</h1>
            
            </div> */}
        </section>

        {/* <section className="footer1">
          <div className="col">
            <p>Instagram</p>

            <div className="footer-links">
              <p>Luxe Residance</p>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                "A Perfect Blend
              </h1>
              <h1> of Style and Comfort."</h1>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                A2Z Design & Build
              </h1>
            </div>
          </div>

       
          <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div>
        </section> */}

        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "40px",
                }}
              >
                Architecturally crafted for modern living, Beysu Mansions merges
                expansive spatial dynamics with thoughtful layouts, shaping
                luxury and functionality.
              </h1>
              <p>A2Z Design Studio</p>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>

        <InteriorDesignResidentialSelectionComponent />
      </div>
    </ReactLenis>
  );
}
